import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export const useGetWeekPlanner = (filters) => {
    const intl = useIntl();
    const { data, isLoading, error, refetch } = useQuery([TaskQueryKey.WeekPlanner, filters], () => api.base
        .get(`${config.appUrls.tasks}/api/WeekPlanner`, {
        params: filters,
    })
        .then(res => res.data), {
        enabled: true,
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return {
        data,
        error,
        isLoading,
        refetch,
    };
};
